const CONSULTATIONS_VIEW_TABS = ['received', 'sent', 'supervised', 'completed'] as const

export type ConsultationsViewTab = (typeof CONSULTATIONS_VIEW_TABS)[number]

export function getInitialTab(queryTab: unknown): ConsultationsViewTab {
  const value = Array.isArray(queryTab) ? queryTab[0] : queryTab

  if (CONSULTATIONS_VIEW_TABS.includes(value as ConsultationsViewTab)) {
    return value as ConsultationsViewTab
  }

  return 'received'
}
